import { render, staticRenderFns } from "./addUserForInsurance.vue?vue&type=template&id=72cf8419&scoped=true&"
import script from "./addUserForInsurance.vue?vue&type=script&lang=js&"
export * from "./addUserForInsurance.vue?vue&type=script&lang=js&"
import style0 from "./addUserForInsurance.vue?vue&type=style&index=0&id=72cf8419&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf8419",
  null
  
)

export default component.exports